import type PocketBase from 'pocketbase';
import type { GlobalValuesResponse } from '$types/pocketbase';
import { Collections } from '$types/pocketbase';
import type { GlobalValues } from '$types/interfaces';

export const getAllKeyValue = (pb: PocketBase) =>
  pb
    .collection(Collections.GlobalValues)
    .getList<GlobalValuesResponse>(1, 200, {
      autoCancel: false
    })
    .then((response) => response.items)
    .then<GlobalValues>((items) => Object.fromEntries(items.map((item) => [item.key, item.value])));

export const getAll = (pb: PocketBase) =>
  pb
    .collection(Collections.GlobalValues)
    .getList<GlobalValuesResponse>(1, 200, {
      autoCancel: false
    })
    .then((response) => response.items);

export const getByKey = (pb: PocketBase) => (key: string) =>
  pb
    .collection(Collections.GlobalValues)
    .getFirstListItem<GlobalValuesResponse>(`key = '${key}'`)
    .then<GlobalValues>((response) => ({ [response.key]: response.value }))
    .catch<GlobalValues>(() => ({}));

export const update = (pb: PocketBase) => (id: string, value: string) =>
  pb.collection(Collections.GlobalValues).update<GlobalValuesResponse>(id, { value });

export const updateByKey = (pb: PocketBase) => (key: string, value: string) =>
  pb
    .collection(Collections.GlobalValues)
    .getFirstListItem<GlobalValuesResponse>(`key = '${key}'`)
    .then((existing) => update(pb)(existing.id, value));
